/**
 * Cliente Supabase (Vite).
 * Em build de teste/produção, VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórios —
 * sem eles o bundle caía em fallbacks antigos e lia outro projeto (tudo “zerado” no DRE previsto).
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const envUrl = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim();
const envKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim();

/** Só em `vite dev` local — nunca use estes valores em deploy de teste/prod. */
const DEV_FALLBACK_URL = 'https://bd-supabase.0j5zde.easypanel.host/';
const DEV_FALLBACK_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyAgCiAgICAicm9sZSI6ICJzZXJ2aWNlX3JvbGUiLAogICAgImlzcyI6ICJzdXBhYmFzZS1kZW1vIiwKICAgICJpYXQiOiAxNjQxNzY5MjAwLAogICAgImV4cCI6IDE3OTk1MzU2MDAKfQ.DaYlNEoUrrEn2Ig7tqibS-PHK5vgusbcbo7X36XVt4Q';

const supabaseUrl = envUrl || DEV_FALLBACK_URL;
const supabaseAnonKey = envKey || DEV_FALLBACK_ANON_KEY;

if (!envUrl || !envKey) {
  console.error('Supabase env ausente no build, usando fallback controlado', {
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    hasUrl: Boolean(envUrl),
    hasKey: Boolean(envKey),
    fallbackUrl: DEV_FALLBACK_URL,
  });
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Evita respostas GET em cache do browser após sync/upsert (lista parecia “congelada”).
const fetchNoStore: typeof fetch = (input, init) =>
  fetch(input, { ...init, cache: 'no-store' });

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  global: { fetch: fetchNoStore },
  auth: {
    autoRefreshToken: false,
    persistSession: true,
    detectSessionInUrl: true,
  },
});